<template>
  <div class="letter_wrap set-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('user.setting') }}
      </div>
    </div>

    <div class="settings-card">
      <van-cell
        class="settings-cell"
        is-link
        @click="$router.push('/language')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="list-switching"
              size="22"
            />
            <span class="custom-title">{{ $t('safe.language') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="settings-cell"
        is-link
        @click="$router.push('/setpwd')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="lock"
              size="22"
            />
            <span class="custom-title">{{ $t('safe.signInPassword') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="settings-cell"
        is-link
        @click="$router.push('/setpaypwd')"
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="shield-o"
              size="22"
            />
            <span class="custom-title">{{ $t('safe.paymentPassword') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell class="settings-cell">
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="brush-o"
              size="22"
            />
            <span class="custom-title">{{ $t('feng.cache') }}</span>
          </span>
        </template>
      </van-cell>
      <van-cell
        class="settings-cell"
        value=" V1.0.0 "
      >
        <template #title>
          <span class="menu-title">
            <van-icon
              class="menu-icon"
              name="info-o"
              size="22"
            />
            <span class="custom-title">{{ $t('feng.version') }}</span>
          </span>
        </template>
      </van-cell>
    </div>

    <div class="logout-wrap">
      <button
        type="button"
        class="history_coupon"
        @click="logout"
      >
        <span>{{ $t('safe.signOut') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';

export default {
  name: "Set",
  data() {
    return {
      title: "title_" + (this.$i18n.locale || "zh_cn"),
      content: "content_" + (this.$i18n.locale || "zh_cn"),
      app: null,
      data: {},
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data;
      });
    },
    logout() {
      localStorage.removeItem('token');
      this.$router.replace("/");
    }
  }
};
</script>

<style lang="less" scoped>
.set-page {
  min-height: 100vh;
  padding-bottom: 96px;
  background: #fff;
  color: #16223a;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.page-top {
  position: relative;
  top: 0;
  left: 50%;
  z-index: 10;
  transform: translateX(-50%);
  background: #fff;
  color: #16223a;
  border-bottom: 1px solid rgba(240, 242, 245, 1);
  box-sizing: border-box;

  .back_left {
    // filter: invert(1);
    opacity: 0.88;
  }

  .big_tit {
    max-width: 72%;
    color: #16223a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
  }
}

.settings-card {
  margin: 14px 16px 0;
  padding: 4px 14px;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid rgba(255, 93, 122, 0.16);
  background: #fff;
  box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
  box-sizing: border-box;
}

/deep/ .van-cell {
  min-height: 54px;
  padding: 0;
  display: flex;
  align-items: center;
  background: transparent;
  color: #16223a;
  line-height: 54px;
}

/deep/ .van-cell:not(:last-child) {
  border-bottom: 1px solid rgba(240, 242, 245, 1);
}

/deep/ .van-cell::after {
  display: none;
}

/deep/ .van-cell__title {
  min-width: 0;
}

/deep/ .van-cell__value {
  color: #6d7688;
  font-size: 14px;
}

/deep/ .van-cell__right-icon {
  color: #6d7688;
  font-size: 16px;
  line-height: 54px;
}

.menu-title {
  min-width: 0;
  display: flex;
  align-items: center;
}

.menu-icon {
  flex: 0 0 auto;
  margin-right: 10px;
  color: #ff5d7a;
}

.custom-title {
  overflow: hidden;
  color: #16223a;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.logout-wrap {
  margin: 18px 16px 0;
}

.history_coupon {
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid rgba(255, 93, 122, 0.42);
  background: rgba(255, 93, 122, 0.12);
  color: #ff5d7a;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

@media screen and (max-width: 374px) {
  .settings-card,
  .logout-wrap {
    margin-right: 12px;
    margin-left: 12px;
  }
}

.set-page {
  min-height: 100vh;
  padding-bottom: calc(84px + env(safe-area-inset-bottom));
  background: #201c1d;
  color: #f4ece7;
}

.page-top {
  height: 44px;
  background: #201c1d;
  color: #f3c99e;
  border-bottom-color: #302723;
}

.page-top .back_left {
  opacity: 1;
  filter: brightness(0) saturate(100%) invert(86%) sepia(18%) saturate(702%) hue-rotate(333deg) brightness(99%) contrast(92%);
}

.page-top .big_tit {
  color: #f3c99e;
}

.settings-card {
  margin: 12px 10px 0;
  padding: 4px 12px;
  border: 1px solid #75654f;
  border-radius: 9px;
  background: linear-gradient(110deg, #232323, #303030);
  box-shadow: 0 10px 24px rgba(0, 0, 0, .2);
}

/deep/ .van-cell {
  min-height: 50px;
  color: #f4ece7;
  line-height: 50px;
}

/deep/ .van-cell:not(:last-child) {
  border-bottom-color: #4a4038;
}

/deep/ .van-cell__value,
/deep/ .van-cell__right-icon {
  color: #b28d6c;
}

/deep/ .van-cell__right-icon {
  line-height: 50px;
}

.menu-icon {
  color: #f3c99e;
}

.custom-title {
  color: #f4ece7;
  font-weight: 500;
}

.logout-wrap {
  margin: 12px 10px 0;
}

.history_coupon {
  height: 42px;
  border: 0;
  border-radius: 7px;
  background: linear-gradient(120deg, #f5cfa8, #dbab73);
  color: #5a4839;
  box-shadow: 0 6px 14px rgba(0, 0, 0, .22);
}

@media screen and (max-width: 374px) {
  .settings-card,
  .logout-wrap {
    margin-right: 8px;
    margin-left: 8px;
  }
}
</style>
